<template lang="pug">
  include ./../../../mixins
  +b.cabinet-modal
    +e.close(
      @click.prevent="$emit('close')"
    )
      +b.icon--type_close
    +b.bg--white.pa--f_sm.--f_md-md.--f_lg-lg
      validation-observer(
        ref="observer"
        tag="form"
        class="form"
      )
        +b.ma--b_sm.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="'4xl'"
          :color="'black'"
          :tag="'p'"
        ) Reset password
        validation-provider(
          v-slot="{ errors }"
          name="nonFieldErrors"
        )
          +b.ma--b_sm.TEXT-BEMTO(
            :fw="'medium'"
            :lh="'small'"
            :fs="'xs'"
            :color="'red'"
            :tag="'p'"
          ) {{ errors[0] }}
        +b.ug-row--apearance_spaced.--space_md
          +b.ug-cell.ug-cols--12
            +b.input--modal.D-CONTROL-INPUT(
              v-model="formData.email"
              :input-label="'Email address *'"
              :placeholder="'Email address *'"
              :rules="{required: true, email: true}"
              :name="'email'"
              :type="'text'"
              id="email"
            )

          +b.ug-cell.ug-cols--12
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'gray1'"
              :tag="'p'"
            ) We will send you a link to your e-mail address to reset your password.

          +b.ug-cell.ug-cols--12
            +b.button.BUTTON-BEMTO(
              :disabled="isRequest"
              @event="validateBeforeSubmit(formData)"
            ) Reset
</template>

<script>
import FormMixin, { defaultValidatorErrorsParser } from '@/js/mixins/FormMixin'
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import { postRestoreCabinetAPI } from '@/js/services/cabinet'

export default {
  name: 'RestoreCabinet',
  mixins: [
    FormMixin,
    ToggleModalMixin
  ],
  data() {
    return {
      /**
       * Component state.
       */
      formData: {
        email: null,
      },
      isRequest: false,
    }
  },
  methods: {
    /**
     * Submission handler, if validated.
     * @param { Object } data - Send data.
     */
    async send(data) {
      await postRestoreCabinetAPI.execute(
        {}, data
      )
        .then(response => {
          const MESSAGE = {
            title: response.data.item.detail,
            url: '/',
          }
          /**
           * Show success message.
           */
          this.toggleModalMixin(
            'RedirectModal', MESSAGE
          )
        })
    },
    /**
     * After > error display normalization >
     * Set Observer errors.
     *
     * @param { Object } errors - Formatted errors
     */
    setErrors(errors) {
      const error = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/cabinets/RestoreCabinet.vue